import React, { useMemo, ReactElement } from 'react';
import { Request } from 'express';
import { isBrowser } from '@app/utils';
import NonInteractiveViewerContext from '../../state/NonInteractiveViewerContext';
import { isUserAgentNonInteractive } from '../../utils';

type NonInteractiveViewerProviderProps = {
  children: ReactElement[] | ReactElement;
  req?: Request;
  isNonInteractiveViewer?: boolean;
};

/**
 * We use memo here to ensure it runs on the server and client.
 *
 * @param children
 * @param isNonInteractiveViewer
 * @param req
 * @constructor
 */
const NonInteractiveViewerProvider = ({
  children,
  isNonInteractiveViewer,
  req,
}: NonInteractiveViewerProviderProps) => {
  const value = useMemo(() => {
    // Ability to override when provider is init'ed (looking at you bread)
    if (isNonInteractiveViewer) {
      return isNonInteractiveViewer;
    }

    let userAgent: Nullable<string> = null;

    if (isBrowser) {
      // eslint-disable-next-line prefer-destructuring
      userAgent = window.navigator.userAgent;
    } else if (req) {
      if (req?.isCrawler) {
        return true;
      }

      userAgent = req?.headers?.['user-agent'] || null;
    }

    if (!userAgent) {
      return true;
    }

    return isUserAgentNonInteractive(userAgent);
  }, [isNonInteractiveViewer, req?.headers?.['user-agent']]);

  return (
    <NonInteractiveViewerContext.Provider value={value}>
      {children}
    </NonInteractiveViewerContext.Provider>
  );
};

export default NonInteractiveViewerProvider;
